(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jamila-catalog-film"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jamila-catalog-film')) {
  customElements.define('jamila-catalog-film', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.classList.contains('jcf--text-only')) return;
      this.initialize();
      if (!this.controller) {
        this.contentObserver = new MutationObserver(() => this.initialize());
        this.contentObserver.observe(this, { childList: true, subtree: true });
      }
    }
    initialize() {
      if (this.controller) return;
      const video = this.querySelector('video');
      const playButton = this.querySelector('[data-play-toggle]');
      const soundButton = this.querySelector('[data-sound-toggle]');
      const controls = this.querySelector('.jcf__controls');
      if (!video || !playButton || !soundButton || !controls) return;
      this.contentObserver?.disconnect();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const options = { signal };
      this.video = video;
      this.controls = controls;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const autoplayEnabled = this.dataset.autoplay === 'true';
      this.userPaused = false;
      this.manualPlayback = false;
      this.wantsPlayback = autoplayEnabled && !motion.matches;
      this.playRequest = null;
      const readVisibility = () => {
        const rect = video.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 &&
          rect.top < window.innerHeight && rect.left < window.innerWidth;
      };
      this.inView = readVisibility();
      const updateLabel = (button, label) => {
        button.setAttribute('aria-label', label);
        button.title = label;
        const visibleLabel = button.querySelector('[data-control-label]');
        if (visibleLabel) visibleLabel.textContent = label;
      };
      const syncControls = () => {
        const playing = !video.paused && !video.ended;
        const muted = video.muted || video.volume === 0;
        playButton.dataset.playing = String(playing);
        soundButton.dataset.muted = String(muted);
        updateLabel(playButton, playing ? playButton.dataset.pauseLabel : playButton.dataset.playLabel);
        updateLabel(soundButton, muted ? soundButton.dataset.unmuteLabel : soundButton.dataset.muteLabel);
      };
      const requestPlayback = () => {
        if (this.playRequest || !video.paused || signal.aborted) return;
        const request = {};
        this.playRequest = request;
        const finish = error => {
          if (signal.aborted || this.playRequest !== request) return;
          this.playRequest = null;
          if (error && error.name !== 'AbortError') {
            this.dataset.autoplayBlocked = String(error.name === 'NotAllowedError');
          } else if (!error) {
            delete this.dataset.autoplayBlocked;
          }
          syncControls();
        };
        try {
          const playback = video.play();
          if (playback && typeof playback.then === 'function') {
            playback.then(() => finish(), finish);
          } else {
            finish();
          }
        } catch (error) {
          finish(error);
        }
      };
      const syncPlayback = () => {
        const allowed = this.wantsPlayback && !this.userPaused && this.inView && !document.hidden &&
          (!motion.matches || this.manualPlayback);
        video.autoplay = allowed && autoplayEnabled && !motion.matches;
        if (allowed) requestPlayback();
        else video.pause();
        syncControls();
      };
      try {
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        video.addEventListener('play', () => {
          if (!video.paused && !this.wantsPlayback && !video.autoplay && this.inView && !document.hidden) {
            this.userPaused = false;
            this.manualPlayback = true;
            this.wantsPlayback = true;
          }
          delete this.dataset.autoplayBlocked;
          syncControls();
        }, options);
        ['pause', 'ended', 'volumechange'].forEach(name => video.addEventListener(name, syncControls, options));
        playButton.addEventListener('click', () => {
          if (!video.paused && !video.ended) {
            this.userPaused = true;
            this.manualPlayback = false;
            this.wantsPlayback = false;
            video.autoplay = false;
            video.pause();
          } else {
            this.userPaused = false;
            this.manualPlayback = true;
            this.wantsPlayback = true;
            this.inView = readVisibility();
            syncPlayback();
          }
          syncControls();
        }, options);
        soundButton.addEventListener('click', () => {
          const muted = video.muted || video.volume === 0;
          if (muted && video.volume === 0) video.volume = 1;
          video.muted = !muted;
          syncControls();
        }, options);
        motion.addEventListener('change', event => {
          this.manualPlayback = false;
          this.wantsPlayback = !event.matches && autoplayEnabled && !this.userPaused;
          syncPlayback();
        }, options);
        ['loadeddata', 'canplay'].forEach(name => {
          video.addEventListener(name, syncPlayback, { signal, once: true });
        });
        document.addEventListener('visibilitychange', () => {
          this.inView = readVisibility();
          syncPlayback();
        }, options);
        window.addEventListener('pageshow', () => {
          this.inView = readVisibility();
          syncPlayback();
        }, options);
        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(entries => {
            this.inView = entries.some(entry => entry.isIntersecting);
            syncPlayback();
          }, { threshold: [0, 0.1] });
          this.visibilityObserver.observe(video);
        }
        controls.hidden = false;
        video.controls = false;
        syncPlayback();
      } catch {
        video.autoplay = false;
        this.restoreNativeControls();
      }
    }
    restoreNativeControls() {
      if (this.video) this.video.controls = true;
      if (this.controls) this.controls.hidden = true;
    }
    disconnectedCallback() {
      this.contentObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.playRequest = null;
      this.wantsPlayback = false;
      if (this.video) {
        this.video.autoplay = false;
        this.video.pause();
      }
      this.restoreNativeControls();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jamila-home-film"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jamila-home-film')) {
  customElements.define('jamila-home-film', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.classList.contains('jhf--text-only')) return;
      this.initialize();
      if (!this.controller) {
        this.contentObserver = new MutationObserver(() => this.initialize());
        this.contentObserver.observe(this, { childList: true, subtree: true });
      }
    }
    initialize() {
      if (this.controller) return;
      const video = this.querySelector('video');
      const playButton = this.querySelector('[data-play-toggle]');
      const soundButton = this.querySelector('[data-sound-toggle]');
      const controls = this.querySelector('.jhf__controls');
      if (!video || !playButton || !soundButton || !controls) return;
      this.contentObserver?.disconnect();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const options = { signal };
      this.video = video;
      this.controls = controls;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const autoplayEnabled = this.dataset.autoplay === 'true';
      this.userPaused = false;
      this.manualPlayback = false;
      this.wantsPlayback = autoplayEnabled && !motion.matches;
      this.playRequest = null;
      const readVisibility = () => {
        const rect = video.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 &&
          rect.top < window.innerHeight && rect.left < window.innerWidth;
      };
      this.inView = readVisibility();
      const updateLabel = (button, label) => {
        button.setAttribute('aria-label', label);
        button.title = label;
        const visibleLabel = button.querySelector('[data-control-label]');
        if (visibleLabel) visibleLabel.textContent = label;
      };
      const syncControls = () => {
        const playing = !video.paused && !video.ended;
        const muted = video.muted || video.volume === 0;
        playButton.dataset.playing = String(playing);
        soundButton.dataset.muted = String(muted);
        updateLabel(playButton, playing ? playButton.dataset.pauseLabel : playButton.dataset.playLabel);
        updateLabel(soundButton, muted ? soundButton.dataset.unmuteLabel : soundButton.dataset.muteLabel);
      };
      const requestPlayback = () => {
        if (this.playRequest || !video.paused || signal.aborted) return;
        const request = {};
        this.playRequest = request;
        const finish = error => {
          if (signal.aborted || this.playRequest !== request) return;
          this.playRequest = null;
          if (error && error.name !== 'AbortError') {
            this.dataset.autoplayBlocked = String(error.name === 'NotAllowedError');
          } else if (!error) {
            delete this.dataset.autoplayBlocked;
          }
          syncControls();
        };
        try {
          const playback = video.play();
          if (playback && typeof playback.then === 'function') {
            playback.then(() => finish(), finish);
          } else {
            finish();
          }
        } catch (error) {
          finish(error);
        }
      };
      const syncPlayback = () => {
        const allowed = this.wantsPlayback && !this.userPaused && this.inView && !document.hidden &&
          (!motion.matches || this.manualPlayback);
        video.autoplay = allowed && autoplayEnabled && !motion.matches;
        if (allowed) requestPlayback();
        else video.pause();
        syncControls();
      };
      try {
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        video.addEventListener('play', () => {
          if (!video.paused && !this.wantsPlayback && !video.autoplay && this.inView && !document.hidden) {
            this.userPaused = false;
            this.manualPlayback = true;
            this.wantsPlayback = true;
          }
          delete this.dataset.autoplayBlocked;
          syncControls();
        }, options);
        ['pause', 'ended', 'volumechange'].forEach(name => video.addEventListener(name, syncControls, options));
        playButton.addEventListener('click', () => {
          if (!video.paused && !video.ended) {
            this.userPaused = true;
            this.manualPlayback = false;
            this.wantsPlayback = false;
            video.autoplay = false;
            video.pause();
          } else {
            this.userPaused = false;
            this.manualPlayback = true;
            this.wantsPlayback = true;
            this.inView = readVisibility();
            syncPlayback();
          }
          syncControls();
        }, options);
        soundButton.addEventListener('click', () => {
          const muted = video.muted || video.volume === 0;
          if (muted && video.volume === 0) video.volume = 1;
          video.muted = !muted;
          syncControls();
        }, options);
        motion.addEventListener('change', event => {
          this.manualPlayback = false;
          this.wantsPlayback = !event.matches && autoplayEnabled && !this.userPaused;
          syncPlayback();
        }, options);
        ['loadeddata', 'canplay'].forEach(name => {
          video.addEventListener(name, syncPlayback, { signal, once: true });
        });
        document.addEventListener('visibilitychange', () => {
          this.inView = readVisibility();
          syncPlayback();
        }, options);
        window.addEventListener('pageshow', () => {
          this.inView = readVisibility();
          syncPlayback();
        }, options);
        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(entries => {
            this.inView = entries.some(entry => entry.isIntersecting);
            syncPlayback();
          }, { threshold: [0, 0.1] });
          this.visibilityObserver.observe(video);
        }
        controls.hidden = false;
        video.controls = false;
        syncPlayback();
      } catch {
        video.autoplay = false;
        this.restoreNativeControls();
      }
    }
    restoreNativeControls() {
      if (this.video) this.video.controls = true;
      if (this.controls) this.controls.hidden = true;
    }
    disconnectedCallback() {
      this.contentObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.playRequest = null;
      this.wantsPlayback = false;
      if (this.video) {
        this.video.autoplay = false;
        this.video.pause();
      }
      this.restoreNativeControls();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jamila-nailtips-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jamila-nailtips-intro')) {
    customElements.define('jamila-nailtips-intro', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || this.classList.contains('jnti--text-only')) return;
        this.initialize();
        if (!this.controller) {
          this.contentObserver = new MutationObserver(() => this.initialize());
          this.contentObserver.observe(this, { childList: true, subtree: true });
        }
      }
      initialize() {
        if (this.controller) return;
        const video = this.querySelector('video');
        const button = this.querySelector('[data-play-toggle]');
        if (!video || !button) return;
        this.contentObserver?.disconnect();
        this.controller = new AbortController();
        this.video = video;
        this.button = button;
        const options = { signal: this.controller.signal };
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.wantsPlayback = this.dataset.autoplay === 'true' && !motion.matches;
        this.inView = false;
        const syncButton = () => {
          const playing = !video.paused && !video.ended;
          const label = playing ? button.dataset.pauseLabel : button.dataset.playLabel;
          button.dataset.playing = String(playing);
          button.setAttribute('aria-label', label);
          button.title = label;
        };
        const syncPlayback = () => {
          if (this.wantsPlayback && this.inView && !document.hidden) {
            const playback = video.play();
            if (playback && typeof playback.catch === 'function') {
              playback.catch(error => {
                if (error.name !== 'AbortError') this.wantsPlayback = false;
                syncButton();
              });
            }
          } else {
            video.pause();
          }
        };
        try {
          video.autoplay = false;
          video.muted = true;
          video.playsInline = true;
          ['play', 'pause', 'ended'].forEach(name => video.addEventListener(name, syncButton, options));
          button.addEventListener('click', () => {
            this.wantsPlayback = video.paused || video.ended;
            syncPlayback();
          }, options);
          motion.addEventListener('change', event => {
            if (event.matches) {
              this.wantsPlayback = false;
              video.pause();
            }
          }, options);
          document.addEventListener('visibilitychange', syncPlayback, options);
          if ('IntersectionObserver' in window) {
            this.visibilityObserver = new IntersectionObserver(entries => {
              this.inView = entries.some(entry => entry.isIntersecting);
              syncPlayback();
            }, { threshold: 0.1 });
            this.visibilityObserver.observe(video);
          } else {
            this.inView = true;
          }
          syncButton();
          button.hidden = false;
          video.controls = false;
          syncPlayback();
        } catch {
          this.restoreNativeControls();
        }
      }
      restoreNativeControls() {
        if (this.video) this.video.controls = true;
        if (this.button) this.button.hidden = true;
      }
      disconnectedCallback() {
        this.contentObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.controller?.abort();
        this.controller = null;
        this.wantsPlayback = false;
        this.video?.pause();
        this.restoreNativeControls();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jamila-shop-navigation"]) return;
  try {
    
  const positionJamilaShopNavigation = () => {
    document.querySelectorAll('.jms-nav__scroll').forEach(scroller => {
      const active = scroller.querySelector('[aria-current="page"]');
      if (!active || scroller.scrollWidth <= scroller.clientWidth) return;
      const offset = active.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft;
      scroller.scrollLeft = Math.max(0, offset - (scroller.clientWidth - active.offsetWidth) / 2);
    });
  };
  positionJamilaShopNavigation();
  document.addEventListener('shopify:section:load', positionJamilaShopNavigation);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jamila-signature-film"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jamila-signature-film-v2')) {
  customElements.define('jamila-signature-film-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.classList.contains('jsf--text-only')) return;
      this.initialize();
      if (!this.controller) {
        this.contentObserver = new MutationObserver(() => this.initialize());
        this.contentObserver.observe(this, { childList: true, subtree: true });
      }
    }
    initialize() {
      if (this.controller) return;
      const video = this.querySelector('video');
      const playButton = this.querySelector('[data-play-toggle]');
      const soundButton = this.querySelector('[data-sound-toggle]');
      const controls = this.querySelector('.jsf__controls');
      if (!video || !playButton || !soundButton || !controls) return;
      this.contentObserver?.disconnect();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const options = { signal };
      this.video = video;
      this.controls = controls;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const autoplayEnabled = this.dataset.autoplay === 'true';
      this.userPaused = false;
      this.manualPlayback = false;
      this.wantsPlayback = autoplayEnabled && !motion.matches;
      this.playRequest = null;
      const readVisibility = () => {
        const rect = video.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 &&
          rect.top < window.innerHeight && rect.left < window.innerWidth;
      };
      this.inView = readVisibility();
      const updateLabel = (button, label) => {
        button.setAttribute('aria-label', label);
        button.title = label;
        const visibleLabel = button.querySelector('[data-control-label]');
        if (visibleLabel) visibleLabel.textContent = label;
      };
      const syncControls = () => {
        const playing = !video.paused && !video.ended;
        const muted = video.muted || video.volume === 0;
        playButton.dataset.playing = String(playing);
        soundButton.dataset.muted = String(muted);
        updateLabel(playButton, playing ? playButton.dataset.pauseLabel : playButton.dataset.playLabel);
        updateLabel(soundButton, muted ? soundButton.dataset.unmuteLabel : soundButton.dataset.muteLabel);
      };
      const requestPlayback = () => {
        if (this.playRequest || !video.paused || signal.aborted) return;
        const request = {};
        this.playRequest = request;
        const finish = error => {
          if (signal.aborted || this.playRequest !== request) return;
          this.playRequest = null;
          if (error && error.name !== 'AbortError') {
            this.dataset.autoplayBlocked = String(error.name === 'NotAllowedError');
          } else if (!error) {
            delete this.dataset.autoplayBlocked;
          }
          syncControls();
        };
        try {
          const playback = video.play();
          if (playback && typeof playback.then === 'function') {
            playback.then(() => finish(), finish);
          } else {
            finish();
          }
        } catch (error) {
          finish(error);
        }
      };
      const syncPlayback = () => {
        const allowed = this.wantsPlayback && !this.userPaused && this.inView && !document.hidden &&
          (!motion.matches || this.manualPlayback);
        video.autoplay = allowed && autoplayEnabled && !motion.matches;
        if (allowed) requestPlayback();
        else video.pause();
        syncControls();
      };
      try {
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        video.addEventListener('play', () => {
          if (!video.paused && !this.wantsPlayback && !video.autoplay && this.inView && !document.hidden) {
            this.userPaused = false;
            this.manualPlayback = true;
            this.wantsPlayback = true;
          }
          delete this.dataset.autoplayBlocked;
          syncControls();
        }, options);
        ['pause', 'ended', 'volumechange'].forEach(name => video.addEventListener(name, syncControls, options));
        playButton.addEventListener('click', () => {
          if (!video.paused && !video.ended) {
            this.userPaused = true;
            this.manualPlayback = false;
            this.wantsPlayback = false;
            video.autoplay = false;
            video.pause();
          } else {
            this.userPaused = false;
            this.manualPlayback = true;
            this.wantsPlayback = true;
            this.inView = readVisibility();
            syncPlayback();
          }
          syncControls();
        }, options);
        soundButton.addEventListener('click', () => {
          const muted = video.muted || video.volume === 0;
          if (muted && video.volume === 0) video.volume = 1;
          video.muted = !muted;
          syncControls();
        }, options);
        motion.addEventListener('change', event => {
          this.manualPlayback = false;
          this.wantsPlayback = !event.matches && autoplayEnabled && !this.userPaused;
          syncPlayback();
        }, options);
        ['loadeddata', 'canplay'].forEach(name => {
          video.addEventListener(name, syncPlayback, { signal, once: true });
        });
        document.addEventListener('visibilitychange', () => {
          this.inView = readVisibility();
          syncPlayback();
        }, options);
        window.addEventListener('pageshow', () => {
          this.inView = readVisibility();
          syncPlayback();
        }, options);
        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(entries => {
            this.inView = entries.some(entry => entry.isIntersecting);
            syncPlayback();
          }, { threshold: [0, 0.1] });
          this.visibilityObserver.observe(video);
        }
        controls.hidden = false;
        video.controls = false;
        syncPlayback();
      } catch {
        video.autoplay = false;
        this.restoreNativeControls();
      }
    }
    restoreNativeControls() {
      if (this.video) this.video.controls = true;
      if (this.controls) this.controls.hidden = true;
    }
    disconnectedCallback() {
      this.contentObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.playRequest = null;
      this.wantsPlayback = false;
      if (this.video) {
        this.video.autoplay = false;
        this.video.pause();
      }
      this.restoreNativeControls();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
